import Button from "src/components/Button";
import styles from "../AddBeneficiary/styles.module.scss";

interface Props {
  setKycOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setVerified: React.Dispatch<React.SetStateAction<boolean>>;
  bvn: string;
  setBvn: React.Dispatch<React.SetStateAction<string>>;
}

const KYCVerify = ({ setKycOpen, bvn, setBvn, setVerified }: Props) => {
  const handleSubmit = (e: any) => {
    e.preventDefault();
    setVerified(true);
    setKycOpen(false);
  };

  return (
    <>
      <div className="rounded-md bg-white p-8">
        <div className="">
          <h1 className="mb-2 text-xl font-semibold">
            Add your BVN details below
          </h1>
          <p className="mb-8 text-sm text-gray-500">
            We use this information to recognise who our customers are
          </p>

          <div className="">
            <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
              <div
                className={
                  styles["transferModal--content-form_container__group"]
                }
              >
                <p className="text-sm">Your BVN</p>
                <input
                  className={
                    styles[
                      "transferModal--content-form_container__select-css__content__input"
                    ]
                  }
                  type="text"
                  inputMode="numeric"
                  name="bvn"
                  value={bvn}
                  placeholder="Enter your BVN here"
                  onChange={(e: any) => {
                    // fetchDetails(e.target.value);
                    setBvn(e.target.value);
                  }}
                />
              </div>

              <div className="mt-4 flex gap-4">
                <Button
                  type="reset"
                  label="Cancel"
                  design="secondary"
                  onClick={() => setKycOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  label="Add Details"
                  design="primary"
                  disabled={bvn.length !== 11}
                  // loader={updateBankDetailsLoading}
                  // onClick={handleSubmit}
                >
                  Add Details
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default KYCVerify;
